import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';

function FoodOrganization() {
  return (
    <Layout>
      <SEO
        keywords={[
          `Организация питания`,
          `Профф`,
          `Пыть-Ях`,
          `Питание`,
        ]}
        title='Организация питания'
      />

      <section className='flex flex-col items-center '>
        <h1 className=' text-center text-2xl uppercase tracking-wider text-gray-800 font-bold mb-4'>
          Организация питания в образовательной организации
        </h1>
        
        <div className='w-full bg-white p-4 py-6 my-4 rounded shadow-lg'>
          <p className='text-lg leading-relaxed mb-4'>
            Расписание занятий предусматривает перерыв на обед с достаточной продолжительностью. В организации соблюдается питьевой режим. Учебная аудитория оснащена одноразовыми стаканчиками, бутилированной питьевой водой, кулером; можно попить горячий чай, кофе. С целью обеспечения возможности питания обучающихся планируется заключение договора на оказание услуг по организации питания со сторонним подрядчиком.
          </p>
        </div>

        <div className='w-full bg-white p-4 py-6 my-4 rounded shadow-lg'>
          <h2 className='text-green-700 text-2xl mb-4 text-center'>
            Документы
          </h2>
          <ul className='list-none px-4 space-y-3'>
            <li>
              <a 
                href='/health_protection_regulation.pdf' 
                download='health_protection_regulation.pdf'
                className='inline-flex items-center text-blue-600 hover:text-blue-800 hover:underline'
              >
                <span className='mr-2'>📄</span>
                Положение об охране здоровья слушателей (PDF)
              </a>
            </li>
          </ul>
        </div>
      </section>
    </Layout>
  );
}

export default FoodOrganization;
